import { useTranslation } from "react-i18next";
import { Search, ShoppingCart, Truck, MapPin, Bike, Car, Store, User } from "lucide-react";
import PublicLayout from "@/components/public/PublicLayout";
import Seo from "@/components/public/Seo";
import { PageHero, SectionHead, StepList, CtaBand } from "@/components/public/blocks";

const VEHICLES = [
  { key: "motorcycle", icon: Bike },
  { key: "car", icon: Car },
  { key: "van", icon: Truck },
  { key: "truck", icon: Truck },
];

export default function HowItWorks() {
  const { t } = useTranslation();
  const steps = [
    { icon: Search, title: t("site.how.s1t"), body: t("site.how.s1b") },
    { icon: ShoppingCart, title: t("site.how.s2t"), body: t("site.how.s2b") },
    { icon: Truck, title: t("site.how.s3t"), body: t("site.how.s3b") },
    { icon: MapPin, title: t("site.how.s4t"), body: t("site.how.s4b") },
  ];
  const roles = [
    { icon: User, title: t("site.how.rCustT"), body: t("site.how.rCustB") },
    { icon: Store, title: t("site.how.rMerchT"), body: t("site.how.rMerchB") },
    { icon: Bike, title: t("site.how.rCourT"), body: t("site.how.rCourB") },
  ];
  return (
    <PublicLayout testId="how-page">
      <Seo path="/how-it-works" title={t("site.seo.howTitle")} description={t("site.seo.howDesc")} />
      <PageHero badge={t("site.nav.how")} title={t("site.how.title")} subtitle={t("site.how.subtitle")} />
      <section className="max-w-7xl mx-auto px-5 pb-20"><StepList steps={steps} /></section>
      <section className="max-w-7xl mx-auto px-5 py-20 border-t border-white/10 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <SectionHead title={t("landing.vehiclesTitle")} subtitle={t("landing.vehiclesSub")} />
          <ul className="grid grid-cols-2 gap-4">
            {VEHICLES.map((v) => (
              <li key={v.key} className="rounded-2xl border border-white/10 bg-white/[0.04] p-5" data-testid={`vehicle-${v.key}`}>
                <v.icon className="w-6 h-6 text-brand" aria-hidden="true" />
                <p className="font-display font-bold mt-3">{t(`vehicle.${v.key}`)}</p>
              </li>
            ))}
          </ul>
        </div>
        <img src="/images/delivery-van.jpg" alt={t("site.how.vanAlt")} width="900" height="1100" loading="lazy"
          className="w-full max-h-[520px] object-cover rounded-3xl border border-white/10" />
      </section>
      <section className="max-w-7xl mx-auto px-5 py-20 border-t border-white/10">
        <SectionHead title={t("site.how.rolesTitle")} />
        <ul className="grid gap-4 md:grid-cols-3">
          {roles.map((r) => (
            <li key={r.title} className="rounded-2xl border border-white/10 bg-white/[0.04] p-6">
              <r.icon className="w-6 h-6 text-brand" aria-hidden="true" />
              <h3 className="font-display font-bold text-lg mt-3">{r.title}</h3>
              <p className="text-sm text-slate-400 mt-2">{r.body}</p>
            </li>
          ))}
        </ul>
      </section>
      <CtaBand title={t("site.cats.ctaTitle")} body={t("site.cats.ctaBody")} to="/register" cta={t("landing.startShopping")} testId="how-shop-cta" />
    </PublicLayout>
  );
}
